export default __webpack_public_path__ + "static/media/execute_subject_typeofQuestions.ac0c9ad1.png";